<template>
  <div>
    <transition
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      enter-active-class="transition-opacity duration-300 ease-out"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
      leave-active-class="transition-opacity duration-300 ease-in delay-100"
    >
      <div
        v-show="showModal"
        id="modal-overlay"
        class="fixed inset-0 bg-white bg-opacity-60 z-10"
      >
        &nbsp;
      </div>
    </transition>
    <transition
      enter-class="opacity-0 scale-50"
      enter-to-class="opacity-100 scale-100"
      enter-active-class="transition-all duration-300 ease-out delay-300"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-75"
      leave-active-class="transition-all duration-300 ease-in"
    >
      <div
        v-show="showModal"
        class="fixed inset-0 flex items-center justify-center z-20"
        id="modal-container"
        v-on:click="closeModal()"
      >
        <div style="width: 750px" class="relative">
          <a
            class="absolute bg-transparent top-2 right-2 rounded-full flex items-center justify-center p-1 cursor-pointer z-20"
            v-on:click="closeModal()"
          >
            <svg
              class="w-6 h-6 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </a>
          <div
            id="modal"
            class="relative bg-gray-50 rounded-2xl shadow-lg text-left overflow-hidden md:aspect-w-16 md:aspect-h-9 aspect-w-4 aspect-h-5"
          >
            <iframe
              :src="videoUrl"
              class="w-full h-full absolute inset-0"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    intervalTime: {
      type: Number,
      required: true,
    },
    videoDesktopUrl: {
      type: String,
      required: true,
    },
    videoMobileUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
      showModal: false,
      isMobile: false,
      videoUrl: "",
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
      this.videoUrl =
      this.isMobile == true ? this.videoMobileUrl : this.videoDesktopUrl;
      if (this.intervalTime > 0) {
        // Clear timer after opening modal: it will open automatically only once.
        clearInterval(this.timer);
      }
    },
    closeModal() {
      this.showModal = false;
      this.videoUrl = "";
    },
  },
  mounted() {
    if (this.intervalTime > 0) {
      // Opens modal after 'intervalTime' seconds.
      this.timer = setInterval(() => {
        this.openModal();
      }, this.intervalTime * 1000);
    }
  },
  created() {
    // Check if is mobile.
    this.isMobile = false;
    if (screen.width <= 760) {
      this.isMobile = true;
    }
  },
  deactivated() {
    if (this.intervalTime > 0) {
      // Deactivate timer when go next/back form.
      clearInterval(this.timer);
    }
  },
};
</script>
